/**
 * Canonical OTK Quality preview_stats → dashboard model.
 * After a successful response, numeric 0 / empty buckets are authoritative —
 * never fall back to a previous period snapshot because the new value is 0.
 */

export const EMPTY_OTK_PREVIEW_MODEL = Object.freeze({
  int: Object.freeze([0, 0]),
  ext: Object.freeze([0, 0]),
  rek: Object.freeze([0, 0]),
  otkCompanies: Object.freeze([0, 0, 0, 0]),
});

function num(v) {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}

/**
 * @param {*} payload raw getRequest body or { data: ... }
 * @returns {{ int: number[], ext: number[], rek: number[], otkCompanies: number[] }}
 */
export function normalizeOtkPreviewStats(payload) {
  const d = payload?.data ?? payload ?? {};
  const certs = Array.isArray(d.certs) ? d.certs : [0, 0, 0, 0];
  return {
    int: [num(d.int_open), num(d.int_closed)],
    ext: [num(d.ext_open), num(d.ext_closed)],
    rek: [num(d.rek_open), num(d.rek_closed)],
    otkCompanies: [num(certs[0]), num(certs[1]), num(certs[2]), num(certs[3])],
  };
}

/** Legend / card count from the current authoritative model (0 is valid). */
export function otkPreviewLegendCount(modelSlice, index) {
  if (!Array.isArray(modelSlice) || index < 0 || index >= modelSlice.length) return 0;
  return num(modelSlice[index]);
}

export function otkPreviewTotal(modelSlice) {
  if (!Array.isArray(modelSlice) || modelSlice.length === 0) return 0;
  return modelSlice.reduce((a, b) => a + num(b), 0);
}

/**
 * Apply successive successful responses; each replaces the previous entirely.
 * Used by regression tests (A→B→C) and documents the zero-authoritative contract.
 */
export function applyOtkPreviewStatsSequence(responses) {
  let model = {
    int: [...EMPTY_OTK_PREVIEW_MODEL.int],
    ext: [...EMPTY_OTK_PREVIEW_MODEL.ext],
    rek: [...EMPTY_OTK_PREVIEW_MODEL.rek],
    otkCompanies: [...EMPTY_OTK_PREVIEW_MODEL.otkCompanies],
  };
  for (const res of responses) {
    model = normalizeOtkPreviewStats(res);
  }
  return model;
}
